<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-credit-card-plus fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Création d'un Moyen de Paiement</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_moyen_paiement' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Nom</label>
          <input type="text" id="nom" v-model="moyen.nom" class="form-control form-control-clinique" :class="{ 'is-invalid': error.nom }" placeholder="Nom">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Statut activé -->
        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check form-switch mt-3">
            <input class="form-check-input" type="checkbox" id="isEnabled" v-model="moyen.isEnabled">
            <label class="form-check-label ms-2 fw-semibold" for="isEnabled">Activé ?</label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveMoyen">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      moyen: {
        nom: '',
        isEnabled: true,
        createdBy: null
      },
      error: {
        nom: ''
      }
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.user;
    }
  },
  methods: {
    validateForm() {
      this.error.nom = this.moyen.nom ? '' : 'Le nom est requis';
      return !this.error.nom;
    },
    async saveMoyen() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        const payload = { ...this.moyen, createdBy: this.currentUser.id };
        this.isLoading = true;
        await api.createItem('moyen_paiements', payload);

        this.$router.push({ name: 'liste_moyen_paiement' });
      } catch (error) {
        console.error('Erreur lors de la création du moyen de paiement', error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'moyens_paiement' });
    }
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
